import { render, staticRenderFns } from "./ProductoVeterinaria.vue?vue&type=template&id=745b28d4&scoped=true&"
import script from "./ProductoVeterinaria.vue?vue&type=script&lang=js&"
export * from "./ProductoVeterinaria.vue?vue&type=script&lang=js&"
import style0 from "./ProductoVeterinaria.vue?vue&type=style&index=0&id=745b28d4&scoped=true&lang=css&"
import style1 from "./ProductoVeterinaria.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745b28d4",
  null
  
)

export default component.exports